export const recPreferencesLimit = 16;
